<p-dialog
  header="Please choose the certification period in which the visits being requested will take place."
  appendTo="body"
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [closable]="false"
  [style]="{ width: '450px', minWidth: '200px'}"
  [maximizable]="false"
  >
  <div class="grid grid-cols-12 gap-4 mt-2">
    @for (certPeriod of mappedCertPeriods; track certPeriod; let i = $index) {
      <div class="col-span-12">
        <div class="flex items-center">
          <p-radio-button
            name="certSelected"
            [inputId]="'certPeriod_' + i"
            [value]="certPeriod.value"
            [(ngModel)]="selectedCertPeriod"
          />
          <label [for]="'certPeriod_' + i" class="ml-2">{{ certPeriod.label }}</label>
        </div>
      </div>
    }
  </div>
  <ng-template #footer>
    <button
      type="button"
      pButton
      class="hipps-form"
      label="Continue"
      [disabled]="!selectedCertPeriod"
      (click)="selectCertPeriod()"
    ></button>
  </ng-template>
</p-dialog>
